import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { hasRole, isAuthenticated } from '../../services/authService';

const PrivateRoute = ({
  component: Component,
  requiredRole: requiredRole,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      hasRole(requiredRole) ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
  };
}

export default withRouter(connect(mapStateToProps)(PrivateRoute));



// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.js